export default __webpack_public_path__ + "static/media/consultant.bbf3f130.svg";